// extracted by mini-css-extract-plugin
export default {"container":"Account_container__dFOy+","lineBlock":"Account_lineBlock__pIsYX","unverifiedTag":"Account_unverifiedTag__xSh8E","verifiedTag":"Account_verifiedTag__0jW5D"};